import { render, staticRenderFns } from "./CourseCardsCombined.vue?vue&type=template&id=72757156&"
import script from "./CourseCardsCombined.vue?vue&type=script&lang=js&"
export * from "./CourseCardsCombined.vue?vue&type=script&lang=js&"
import style0 from "./CourseCardsCombined.vue?vue&type=style&index=0&id=72757156&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardsCourseCard: require('/opt/build/repo/components/Cards/CourseCard.vue').default,CardsMoreInfoModal: require('/opt/build/repo/components/Cards/MoreInfoModal.vue').default})
